<template>
  <f7-page>
    <navbar :text="$t('Monitoring_phenologies_navbar_title')" />
    <DxMonitoringPhenologies :key-name="'monitoringPhenologies'" />
  </f7-page>
</template>

<script>
import DxMonitoringPhenologies from '../../components/scouting/DxMonitoringPhenologies.vue';
import navbar from '../../components/NavBar.vue';

export default {
  name: 'MonitoringPhenologies',
  components: {
    DxMonitoringPhenologies,
    navbar,
  },
};
</script>
